import {
  reviewFormValidator,
  type ReviewFormValidator,
} from "@redotech/redo-model/form-builder-form/db-validator/review/review-form-builder-form-validator";
import * as z from "zod/v4";

export const getReviewForm = {
  name: "getReviewForm" as const,
  input: z.object({ formId: z.string() }),
  output: reviewFormValidator as z.ZodType<ReviewFormValidator>, // TODO (Josh) remove cast when Zod is fixed
};
